module.exports = __webpack_public_path__ + "static/media/placeholder-building.bfb01dec.jpg";